export default __webpack_public_path__ + "static/media/Rpi.5e9bb77a.png";